<template>
    <Map class="animated fadeIn" type="Nước mặt" />
</template>

<script>
import Map from '@/components/Map';

export default {
    components: {
        Map
    }
};
</script>
